var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"Home",staticClass:"Home"},[_c('HomeBanner'),_c('div',{staticClass:"home-bg",style:(_vm.backgroundImageStyle)},[_c('ArtRecommendation'),_c('AboutHippoArt'),_c('ArtistRecommendation'),_c('ConsultRecommend')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }